import createReducer from '../../core/helpers/createReducer';
import { MAINTENANCE_TYPES } from '../../core/constants/actionTypes';

export const maintenanceReducer = createReducer(false, {
  [MAINTENANCE_TYPES.RX_SET_IS_UNDER_MAINTENANCE]: (state, action) => {
    return action.payload
  }
});
